/*POINTS, IMPORTS*/
const Points = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Points.vue');
const PointsInterval = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/points/Interval.vue');
const Imports = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/points/Imports.vue');
const Import = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/points/Import.vue');

export default [
  {
    path: 'points',
    name: 'loyaltyvenue.store.points',
    component: Points,
    meta: {
      icon: 'loyaltyvenue.points',
      trans: 'loyaltyvenue:general.titles.points',
    },
  },
  {
    path: 'points/:interval_id',
    name: 'loyaltyvenue.store.points.interval',
    props: true,
    component: PointsInterval,
    meta: {
      trans: 'loyaltyvenue:points.intervals.title',
      up: 'loyaltyvenue.store.points',
    },
  },
  {
    path: 'imports',
    name: 'loyaltyvenue.store.imports',
    component: Imports,
    meta: {
      icon: 'imports',
      trans: 'loyaltyvenue:general.titles.imports',
    },
  },
  {
    path: 'imports/:import_id',
    props: true,
    name: 'loyaltyvenue.store.imports.import',
    component: Import,
    meta: {
      trans: 'loyaltyvenue:general.titles.imports',
      up: 'loyaltyvenue.store.imports',
    },
  },
];


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/routes_points.js